import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import MensureLoader from '../atoms/MensureLoader';

const BYPASS_ROLES = ['admin', 'mensure', 'curator', 'curador'];

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <MensureLoader fullScreen size="md" />;
  }

  if (!user) return <Navigate to="/login" />;



  // Redirecionar para ativação se necessário (admin/mensure/curator têm bypass)
  const isBypass = BYPASS_ROLES.includes(user?.role?.toLowerCase());
  const needsActivation = !isBypass && !user?.activation?.isActivated;

  if (needsActivation) return <Navigate to="/activate" />;

  // Redirecionar para onboarding se não tiver marcas
  const needsOnboarding = !isBypass && !user.hasBrand;
  if (needsOnboarding) return <Navigate to="/onboarding" />;

  return children;

};


export default PrivateRoute;
